import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../_services/auth.service';

export const combinedRoleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  return authService.isStaff() || authService.isStud() || authService.isAdmin();
};
